// extracted by mini-css-extract-plugin
export default {"component":"AddNewFriend_component__JB24s","additionalButtonSettings":"AddNewFriend_additionalButtonSettings__KGxpp"};